module.exports = __webpack_public_path__ + "static/media/orange_animal_birds.bdf5c314.png";